export const excludeMenuList = ['online-course', 'student-blog', 'video'];